export default "__VITE_ASSET__xiCnAiHR__"